import { acceptanceType } from '../../hooks/useAcceptance';
import { useAcceptanceData } from '../../hooks/useAcceptanceData';
import { useFullScreenModal } from '../../hooks/useFullScreenModal';

export function Acceptance() {
  const { acceptance, isLoading } = useAcceptanceData(acceptanceType.offer_for_the_provision_of_paid_services);
  const { Modal, setOpen } = useFullScreenModal();

  return (
    <>
      <button className="text-xs font-medium text-[#FFFFFF] opacity-70 text-start" onClick={() => setOpen(true)}>
        {acceptance?.title}
      </button>
      {acceptance && (
        <Modal title={acceptance.title}>
          <div className="whitespace-pre-line">{acceptance.content}</div>
        </Modal>
      )}
    </>
  );
}
